@if (tilskudd().length) {
    <div class="tilskudd">
        <h2>Tilskudd som kan være aktuelle</h2>
    </div>

    <div class="tilskudd-accordian">
        <hb-accordion [gap]="'sm'" [visKantlinje]="false">
            @for (t of tilskudd(); track t.id) {
                <hb-accordion-element>
                    <span title>{{ t.navn }}</span>

                    <div body>
                        <p>{{ t.beskrivelse }}</p>

                        @if (t.lenke) {
                            <a
                                [href]="t.lenke"
                                target="_blank"
                                rel="noopener noreferrer">
                                Les mer
                            </a>
                        }
                    </div>
                </hb-accordion-element>
            }
        </hb-accordion>
    </div>
}
